// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3vRVY","head":"Table_head__2j-0x","col":"Table_col__1w0hb"};